import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getBreachImpactList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_IMPACTS}?${stringifyParams(queryParams)}`
	);
};
